import { Link } from "@reach/router";
import React from "react";

/**
 * Thin `@reach/router` `Link` wrapper living outside `newui/` (which bans a
 * direct `@reach/router` import). Generic row/action link — see
 * `RfxTabLink` for the tab-bar-specific variant (adds `role="tab"`).
 */
export const RfxRouterLink: React.FC<{
	children: React.ReactNode;
	className?: string;
	"data-testid"?: string;
	to: string;
}> = ({ to, children, className, ...rest }) => (
	<Link
		to={to}
		className={className}
		{...rest}
	>
		{children}
	</Link>
);
